export default __webpack_public_path__ + "static/media/Evaluation_360_img.870c8ace.png";